import React, { useContext, useState } from "react";
import { useSoundPath } from "hooks/useSoundPath";
import { MarketplaceContext } from "pages/MarketPlaceCards";
import ActiveItemDivider from "components/active-item/ActiveItemDivider";
import { createAPI } from "services/api/api";
import { usePopup } from "hooks/usePopup";
import { useDispatch } from "react-redux";
import { setError } from "store/user";

const MultipleListingSwitch = () => {
  const playSound = useSoundPath();
  const { selectMode, setSelectMode, selectedItems, setSelectedItems } =
    useContext(MarketplaceContext);
  const [isLoading, setIsLoading] = useState(false);
  const setPopupHook = usePopup();
  const dispatch = useDispatch();

  const api = createAPI();

  const getSum = () => {
    const total = selectedItems.reduce(
      (sum, item) => sum + Number(item.price),
      0
    );
    return total.toFixed(2);
  };

  const submitListing = () => {
    setIsLoading(true);

    const payload = {
      marketplace_sell: selectedItems.map((item) => {return {listing_id: item.id, price: Number(item.price)}})
    };

    api
      .post(`/marketplace_listing/sell`, payload)
      .then(() => setPopupHook({type: 'multiple-listing-success'}))
      .catch((error) => {
        console.log(error);
        setPopupHook({type: 'multiple-listing-fail'});
        dispatch(setError(error.response.data.message));
      })
      .finally(() => {
        setSelectMode(false);
        setIsLoading(false);
      });
  };

  return (
    <>
      <section className="card-details__combine">
        <h3 className="card-details__combine-title">List Multiple Cards for Sale</h3>
        <div className="card-details__combine-actions">
          <button
            className={`card-details__combine-action card-details__combine-action--select ${
              selectMode === true ? "card-details__combine-action--close" : ""
            }`}
            onClick={() => {
              playSound("main");
              setSelectMode(!selectMode);
              setSelectedItems([]);
            }}
          >
            {selectMode === false ? "Select Cards To List" : "Cancel"}
          </button>
          {selectMode === true && (
            <button
              className={`card-details__combine-action card-details__button--craft ${
                isLoading ? "loading" : ""
              }`}
              type="button"
              disabled={!selectedItems.length || isLoading}
              onClick={submitListing}
            >
              {!selectedItems.length
                ? "Enter Listing Cards"
                : `List selected cards (${selectedItems.length})`}
            </button>
          )}
        </div>

        {selectedItems.length > 0 ? (
          <>
          <p className="card-details__combine-hint">
            Total listing price: <span className="green">${getSum()}</span> <br />
            Total Marketplace Fee (5%): <span className="green">${(getSum() * 0.05).toFixed(2)}</span> <br />
            Total net amount to seller: <span className="green"> ${(getSum() - (getSum() * 0.05)).toFixed(2)} </span>
          </p>
          </>
        ) : (
          <p className="card-details__combine-hint">
            Click 'Select Cards To List' and enter listing prices in lover right field of each card
          </p>
        )}
      </section>
      <ActiveItemDivider />
    </>
  );
};

export default MultipleListingSwitch;
